// extracted by mini-css-extract-plugin
export default {"addedItem":"EditorCrossSellPopup_addedItem__F8tJn","addedItemIcon":"EditorCrossSellPopup_addedItemIcon__QRUNH","addedItemState":"EditorCrossSellPopup_addedItemState__D1acI"};